export class InvalidCaptchaError extends Error {
  public constructor() {
    super()

    this.message = 'errors.invalidCaptcha'
  }
}
